// src/pages/Unsubscribed.jsx
// Page publique de confirmation après un clic sur « Se désinscrire » dans un email
// (fonctions sequence-unsubscribe et campaign-unsubscribe redirigent ici).
import React from "react";
import { Link } from "react-router-dom";
import BrandMark from "@/components/BrandMark";
import { BRAND_NAME } from "@/config/brand";

export default function Unsubscribed() {
  return (
    <div className="min-h-screen bg-[#f9f7f4] text-[#1a1a1a] flex items-center justify-center px-6" style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}>
      <div className="max-w-md w-full bg-white border border-[#e5e0d8] rounded-2xl p-8 text-center">
        <div className="mb-6 flex justify-center"><BrandMark className="text-2xl tracking-[0.15em]" /></div>
        <h1 className="text-2xl font-bold mb-3">Désinscription confirmée</h1>
        <p className="text-[#4a453d] leading-relaxed text-sm">
          Vous ne recevrez plus les emails de cette série. Vos données et votre compte éventuel ne changent pas.
          Une question ? Écrivez à{" "}
          <a href="mailto:support@artkiv.com" className="underline">support@artkiv.com</a>.
        </p>
        <p className="mt-6 text-sm">
          <Link to="/" className="underline text-[#8a6d1f]">{BRAND_NAME}</Link>
        </p>
      </div>
    </div>
  );
}
